import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "crm:text-xs crm:block"
}
const _hoisted_2 = {
  key: 0,
  class: "crm:mx-1"
}

import { ref, watch, toRefs } from 'vue';
import {arrows_right} from '../svg/svgs.js';


export default {
  __name: 'BaseBreadcrumbs',
  props: {
  path: {
    type: Array,
    default() {
      return []
    }
  },
  currentPage: {
    type: String,
    deafult: ''
  }
},
  setup(__props) {

/**
 * @doc
 * Gestisce la visualizzazione di un sistema di breadcrumb
 * Bisogna definire staticamente la rotta in mainPaths
 * Per casistiche di sotto rotte rispetto alla principale (ex. di dettaglio soggetto)
 * si dovrà utilizzare la configurazione dei subPaths (prendete riferimento da pratica)
 */
const props = __props

const basePath = {name: 'Home', link: '/dashboard'}

const mainPaths = {
  documenti: [{...basePath}, {name: 'Documenti', link: '/documenti'}],
  notifiche: [{...basePath}, {name: 'Notifiche', link:'/notifiche'}],
  pratiche: [{...basePath}, {name: 'Pratiche', link: '/pratiche'}],
  omnia: [{...basePath}, {name: 'Opera Omnia', link: '/omnia'}],
  cambio_password: [{...basePath}, {name: 'Cambio Password', link: '/cambio_password'}],
  privacy: [{...basePath}, {name: 'Privacy', link: '/privacy'}],
  rubrica_soggetti: [{...basePath}, {name: 'Rubrica Soggetti', link: '/rubrica_soggetti'}],
  questionari: [{...basePath}, {name: 'Checklist', link: '/questionari'}],
  preventivi: [{...basePath}, {name: 'Preventivi', link: '/preventivi'}],
  storico_preventivi: [{...basePath}, {name: 'Storico Preventivi', link: '/storico_preventivi'}],
  utilita: [{...basePath}, {name: 'Utilità', link: '/utilita'}],
  calcolo: [{...basePath}, {name: 'Utilità', link: '/utilita'}]
}

const subPaths = {
  pratica: props.path,
  dettaglio_rubrica_soggetti: props.path,
}

const paths = ref({...mainPaths, ...subPaths})

const {path} = toRefs(props)
watch(path, (newValue) => {
  subPaths.pratica = newValue;
  subPaths.dettaglio_rubrica_soggetti = newValue
  subPaths.preventivo = newValue
  subPaths.calcolo = newValue
  paths.value = {...mainPaths, ...subPaths}
})

/**
 * Verifica se siamo nella pagina corrente
 * Se si mostra l'attuale percorso come un plain text
 * Se no mostra l'attuale percorso come un link
 * @param index
 * @return {boolean}
 */
function isNotCurrent(index) {
  return (index + 1) !== paths.value[props.currentPage].length;
}

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")

  return (paths.value && paths.value[__props.currentPage] !== undefined)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paths.value[__props.currentPage], (item, index) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(isNotCurrent(index) ? 'a' : 'span'), {
            href: isNotCurrent(index) ? item.link : null
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass([isNotCurrent(index) ? 'crm:underline! crm:cursor-pointer' : 'crm:text-primary!'])
              }, _toDisplayString(item.name), 3 /* TEXT, CLASS */),
              ((index + 1) !== paths.value[__props.currentPage].length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _createVNode(_component_base_icon, {
                      icon: _unref(arrows_right),
                      "stroke-width": "2",
                      sizing: {width:'8px', height: '8px'}
                    }, null, 8 /* PROPS */, ["icon"])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href"]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}
}

}